export default "__VITE_ASSET__7afd8edb__$_?nuxt_component=async__"